export default class ExtensionTableDTO {
    ExtensionEnum = {}

    // eslint-disable-next-line no-unused-vars
    formatType(model) {
        throw new Error('formatType not implemented');
    }

    // eslint-disable-next-line no-unused-vars
    static run(samples) {
        throw new Error('static run not configured');
    }

    // eslint-disable-next-line no-unused-vars
    static getHoverTextStatic(model, attribute) {
        throw new Error('getHoverTextStatic not configured')
    }

    /**
     * Loops through each of the models in the collection and injects the additional fields
     * @param {any} models 
     * @returns model collection with additional fields injected in
     */
    formattedPayload(models) {
        const payload = [];

        models.forEach((model) => {
            payload.push(this.formatType(model));
        })

        return payload;
    }

    /**
     * Get the key name to display as the tooltip text
     * @param {string} extensionKey 
     * @param {string} attributeNumber 
     * @returns {string}
     */
    getHoverText(extensionKey, attributeNumber) {
        const extEnum = this.ExtensionEnum[extensionKey];
        
        if (!extEnum) {
            return '';
        }
        
        return extEnum[attributeNumber] || '';
    }

    /**
     * Returns the given models into a formatted array based on type with updated fields
     * @param models The list of all models that we will need to check on
     * @returns Formatted addition to the table array
     */
    setExtensionTypes(models) {
        return this.formattedPayload(models);
    }
    
    /**
     * Give the formatted payload based on the ExtensionEnum definition
     * @param {string} extensionEnumKey 
     * @param {any} extensionTypeData 
     * @returns 
     */
    formatTable(extensionEnumKey, extensionTypeData) {
        const extensionEnum = this.ExtensionEnum[extensionEnumKey];

        let attrObj = {};
        Object.keys(extensionEnum).forEach((key) => {
            if (extensionTypeData) {
                attrObj[key] = extensionTypeData[extensionEnum[key]];
            }
        });

        return attrObj;
    }

    /**
     * Turn the snake_case key and turn it into a human readable version
     * @param {string} str 
     * @returns {string}
     */
    convertToSentenceCase(str) {
        return str.replace(/^_*(.)|_+(.)/g, (s, c, d) => c ? c.toUpperCase() : ' ' + d.toUpperCase());
    }
}